module.exports = __webpack_public_path__ + "static/media/customers.2fb7020e.svg";